import { ReactComponent as ExclamationIcon } from '../../../../../icons/exclamation-icon.svg';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import TechnicalProblemModal from '../../../../Modal/TechnicalProblemModal';

const Issue = () => {
  const [showModal, setShowModal] = useState(false);
  const { formatMessage } = useIntl();

  const handleModalState = () => setShowModal((prev) => !prev);

  return (
    <div className='integration__issue'>
      <ExclamationIcon />

      <a onClick={handleModalState}>{formatMessage({ id: 'Report technical issue' })}</a>

      <TechnicalProblemModal isOpen={showModal} onRequestClose={handleModalState} />
    </div>
  );
};

export default Issue;
